import { useCallback } from 'react';
import { MessageGroup } from '~/type/Cashback';

export function useMessageMap(messagesCard: MessageGroup[]) {
  const messages =
    messagesCard.find((group: any) => group.codeGroup === 'MESSAGE_MAP')?.params ?? [];

  const getMessage = useCallback(
    (code: string, values?: (string | number)[]): string => {
      const message = messages.find((msg) => msg.code === code)?.value;

      if (!message) return '';

      let formatted = message;

      if (values && values.length > 0) {
        formatted = message.replace(/\{(\d*)\}/g, (match, index) => {
          if (index === '') return String(values.shift());
          return String(values[Number(index)] ?? match);
        });
      }

      return formatted;
    },
    [messages]
  );

  return { getMessage };
}
